const rankingData = [
  { rank: 1, title: '某顶流艺人深夜密会神秘女子', tag: '爆', hot: '982万热度', desc: '狗仔拍到某当红男星深夜与一名女子同回住所，引发粉丝热议' },
  { rank: 2, title: '某女星直播翻车现场合集', tag: '热', hot: '876万热度', desc: '知名女艺人直播带货期间口误连连，网友疯狂转发名场面' },
  { rank: 3, title: '网红CP疑似分手实锤曝光', tag: '热', hot: '754万热度', desc: '百万粉丝情侣博主双双删除合影，粉丝扒出诸多分手细节' },
  { rank: 4, title: '某综艺节目剪辑门事件发酵', tag: '新', hot: '623万热度', desc: '观众发现节目多处恶意剪辑痕迹，节目组紧急发声明回应' },
  { rank: 5, title: '娱乐圈某大佬被爆税务问题', tag: '爆', hot: '598万热度', desc: '知情人士透露知名导演公司正接受税务调查，涉及金额巨大' },
  { rank: 6, title: '热门选秀节目选手黑历史盘点', tag: '新', hot: '487万热度', desc: '网友深扒本届选秀选手过往，多名选手社交账号言论引争议' },
  { rank: 7, title: '某品牌代言人翻车遭网友抵制', tag: '热', hot: '412万热度', desc: '品牌新代言人此前不当言论被翻出，引发大规模网络抵制' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-fire-line text-background-50 text-lg"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">吃瓜热度榜</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10">实时追踪最火爆的吃瓜话题，热度实时更新</p>

        <div className="flex flex-col gap-3">
          {rankingData.map((item) => (
            <a
              key={item.rank}
              href="#ranking"
              onClick={(e) => e.preventDefault()}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 hover:bg-background-200/50 transition-colors cursor-pointer group"
            >
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center font-heading font-bold text-lg shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="font-semibold text-foreground-900 text-sm md:text-base truncate group-hover:text-primary-600 transition-colors">{item.title}</h3>
                  <span className={`shrink-0 text-[10px] font-bold px-1.5 py-0.5 rounded ${
                    item.tag === '爆'
                      ? 'bg-primary-100 text-primary-700'
                      : item.tag === '热'
                      ? 'bg-accent-100 text-accent-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>{item.tag}</span>
                </div>
                <p className="text-xs text-foreground-500 truncate">{item.desc}</p>
              </div>
              <span className="shrink-0 text-xs text-foreground-400 hidden sm:block">{item.hot}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}